import { useMemo } from "react";
import { get_thumbnail } from "./variable";

export function GetHeadlineImage(ele) {

  const imgSrc = useMemo(() => {
    let rawGambar = ele.gambar || ele.mberita_filename || ele.msarana_filename || ele.mprestasi_filename || ele.mkarya_filename || ele.mprogram_filename || ele.mgallery_filename;
    
    let imagePath = null;
    if (rawGambar) {
      if (Array.isArray(rawGambar)) {
        imagePath = rawGambar[0];
      } else if (typeof rawGambar === "string" && rawGambar.startsWith("[")) {
        try {
          const parsed = JSON.parse(rawGambar);
          imagePath = Array.isArray(parsed) ? parsed[0] : parsed;
        } catch (e) {
          imagePath = rawGambar;
        }
      } else {
        imagePath = rawGambar;
      }
    }

    if (!imagePath) return "/placeholder-image.jpg";
    if (imagePath.startsWith("/")) return imagePath;
    return `${get_thumbnail}${imagePath}`;
  }, [ele]);

  const altText = useMemo(
    () => ele.judul || ele.judul_artikel || "Default headline image",
    [ele.judul, ele.judul_artikel]
  );

  return {
    altText,
    imgSrc,
  };
}

export function stripHtml(html) {
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
}
